import React, {Component} from 'react';
import { HashRouter, Route, Link } from "react-router-dom";
import logo from './logo.png';
import './App.css';
import MainBanner from './MainBanner';
import WorkExperience from './WorkExperience';
import Education from './Education';
import Skills from './Skills'
import ThankYou from './ThankYou';
import Projects from './Projects';
import Footer from './Footer';
import About from './About';


function App() {
  return (
    <HashRouter basename='/'>
    <div className="App">
    <MainBanner/>
    <About/>
    <WorkExperience/>
    <Education/>
    <Skills/>
    <Projects/>
    <ThankYou/>
    <Footer/>
    </div>
    </HashRouter>

  );
}

export default App;
